import { Action, createReducer, on } from '@ngrx/store';

import { ProcessAction } from '../actions';
import { ProcessState } from '../states/process.state';

const initialState: ProcessState = {
  overlay: false,
};

const processReducer = createReducer(
  initialState,
  on(ProcessAction.SetOverlay, (state, { overlay }) => ({ overlay }))
);

export function ProcessReducer(
  state: ProcessState | undefined,
  action: Action
) {
  return processReducer(state, action);
}
